<template>
  <d-modal-confirmation
    :title="$t('services.delete.title')"
    :text="modalConfirmationText"
    :modal="modal"
    @submitModal="handleSubmitModal"
    @closeModal="handleCloseModal"
    :isSubmitting="isSubmitting"
  >
  </d-modal-confirmation>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    modalConfirmationText() {
      return this.$t("services.delete.text", {
        displayName: this.item.displayName,
      });
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },
    handleSubmitModal() {
      this.isSubmitting = true;
      window.API.deleteService(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("services.delete.alert.deleted", {
              displayName: this.item.displayName,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("services.delete.alert.could-not-delete"),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
